'use strict';
var React = require('react'),
    _ = require('lodash'),
    Spinner = require('./Spinner'),
    Calendar = require('./Calendar'),
    transformDateResponse = require('../prepareBookingData');

function get(url) {
    // Return a new promise.
    return new Promise(function (resolve, reject) {
        // Do the usual XHR stuff
        var req = new XMLHttpRequest();
        req.open('GET', url);

        req.onload = function () {
            // This is called even on 404 etc
            // so check the status
            if (req.status == 200) {
                // Resolve the promise with the response text
                resolve(req.response);
            }
            else {
                // Otherwise reject with the status text
                // which will hopefully be a meaningful error
                reject(Error(req.statusText));
            }
        };

        // Handle network errors
        req.onerror = function () {
            reject(Error("Network Error"));
        };

        // Make the request
        req.send();
    });
}


class CalendarComponent extends React.Component {
    state = {
        bookedOn: {}
    };
    
    shouldComponentUpdate() {
        return !Object.keys(this.state.bookedOn).length;
    }
    
    render() {
        let url = window.location.protocol + '//ferienwohnungen-iske.de/ftp_xp3/aton_Z0237_dynamic.txt',
            hash = window.location.hash.replace('#', ''),
            nodes = <Spinner />;

        get(url).then(function (dates) {
            this.setState({'bookedOn': transformDateResponse(dates)});
        }.bind(this), function (error) {
            console.error("Failed!", error);
        });

        if (Object.keys(this.state.bookedOn).length && hash) {
            nodes = (
                <div className="col-xs-12">
                    <Calendar bookedOn={_.flatten(this.state.bookedOn[hash])} />
                    <span className="legend"></span>
                    <strong>Belegt</strong>
                </div>
            );
        }

        return nodes;
    }
}

module.exports = CalendarComponent;



// WEBPACK FOOTER //
// ./src/components/CalendarComponent.js